import {
  IPatchUserAccountPayload,
  UserAccountRole,
  UserRolesResponse,
  UsersFetchResponse,
} from '@/types/account';
import { AxiosBaseResponse } from '@/types/common';
import axiosInstance from '@/lib/services/axiosInstance';

export const getUsersList = async (
  page: number,
  pageSize: number
): Promise<UsersFetchResponse> =>
  axiosInstance.get(`/admin/users?page=${page}&page_size=${pageSize}`);

export const getUserRoles = async (): Promise<UserAccountRole[]> =>
  axiosInstance
    .get(`/admin/roles`)
    .then((res) => (res as unknown as UserRolesResponse).data.roles);

export const saveUserAccount = async (
  data: IPatchUserAccountPayload
): Promise<AxiosBaseResponse> => {
  const { id, ...payload } = data;
  return axiosInstance.patch(`/admin/users/${id}`, payload);
};
